
import { useEffect } from 'react'
import './style.scss'
import { useAppSelector } from '../../redux/hooks'


function DashboardEarningsContentArea() {

	const dataLoadRequestFinished: boolean = useAppSelector(state => state.user.dataLoadRequestFinished)

	// Setup test values
	useEffect(() => {
		// setTimeout(() => loadProfileData(), 200)
		if (dataLoadRequestFinished === true) {
		}
	}, [dataLoadRequestFinished])

	return (
		<div className='dashboard-content-area-wrap'>
			<div className='dashboard-content-area-wide-card-wrap'>
			<div className='dashboard-content-area-card'>
					<div className='dashboard-content-area-card-title-wrap'>
						<img
							className='dashboard-content-area-card-title-icon'
							src={`/imgs/icons/dashboard/icon-dashboard-earnings.svg`}
							alt='Earnings'
						/>
						<div className='dashboard-content-area-card-title-label'>Earnings</div>
					</div>
					<div
						className='dashboard-content-area-card-content'
					>
						{/* <div className='dashboard-content-area-earnings-title'>Total Earnings</div> */}
						<div className='dashboard-content-area-card-earnings-wrap'>
							<div className='dashboard-content-area-card-earnings-title'>Total Earnings</div>
							<div className='dashboard-content-area-card-earnings-value'>$0.00</div>
						</div>
						<div className='dashboard-content-area-card-earnings-wrap'>
							<div className='dashboard-content-area-card-earnings-title'>Last Week Earnings</div>
							<div className='dashboard-content-area-card-earnings-value'>$0.00</div>
						</div>
						<div className='dashboard-content-area-card-earnings-wrap'>
							<div className='dashboard-content-area-card-earnings-title'>Last Month Earnings</div>
							<div className='dashboard-content-area-card-earnings-value'>$0.00</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default DashboardEarningsContentArea
